import React, { Component } from 'react'
import { isNullOrWhiteSpace } from '../Services/strings'

class InformationPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            informationPopupIsVisible: false,
        }
        this.cookieSetting =
            'InformationPopupDismissed' + this.props.cookieName + '=true'
    }

    closeIconClickHandler(cookieExpiryTimeInMinute) {
        var date = new Date()
        var floatvalue = parseFloat(cookieExpiryTimeInMinute)
        if (!isNullOrWhiteSpace(cookieExpiryTimeInMinute) && floatvalue > 0) {
            date.setMinutes(date.getMinutes() + floatvalue)
        } else {
            date.setFullYear(date.getFullYear() + 100)
        }
        document.cookie = this.cookieSetting + '; expires=' + date.toUTCString()
        this.setState({ informationPopupIsVisible: true })
    }

    isVisible() {
        return (
            this.state.informationPopupIsVisible ||
            (document.cookie.indexOf(this.cookieSetting) === -1 &&
                !isNullOrWhiteSpace(this.props.informationText))
        )
    }

    render() {
        const classNames =
            'informationpopup' +
            (this.state.informationPopupIsVisible
                ? ' informationpopup--hidden'
                : '')
        return (
            this.isVisible() && (
                <div className={classNames}>
                    <div className="row informationpopup__section">
                        <div
                            className="informationpopup__content"
                            dangerouslySetInnerHTML={{
                                __html: this.props.informationText,
                            }}
                            style={{
                                backgroundImage:
                                    'url(' +
                                    this.props.backgroundImageUrl +
                                    ')',
                            }}
                        ></div>
                        <i
                            className="informationpopup__dismiss fa fa-times"
                            onClick={() =>
                                this.closeIconClickHandler(
                                    this.props.cookieExpiryTime
                                )
                            }
                        ></i>
                    </div>
                </div>
            )
        )
    }
}

export default InformationPopup
